import React from 'react';
import { Box, colors, Grid, Stack, styled, Typography, TypographyProps } from '@mui/material';
import dayjs from 'dayjs';

import { InfoTooltip } from '../../../components/core';
import { ApiKeyResponse } from '../../../store/modules/merchant/types';
import appTheme from '../../../styles/themes/theme';

interface Props {
  apiKey: ApiKeyResponse;
  displayKey: string;
}

type StyledTypography = React.ComponentType<TypographyProps<'span', { component?: 'span' }>>;
const SectionTitle: StyledTypography = styled(Typography)({
  fontSize: '11px',
  color: colors.grey[600],
  fontWeight: 500,
});

const SectionDescription: StyledTypography = styled(Typography)({
  fontSize: '13px',
  color: 'black',

  [appTheme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
});

export const ApiKeyInfo = ({ apiKey, displayKey }: Props) => {
  const { apiKeyId, createdAt } = apiKey;

  return (
    <Grid container alignItems="center" spacing={3}>
      {/* API Key */}
      <Grid item xs={12} sm={4} md={3}>
        <Box>
          <SectionTitle>API Key</SectionTitle>
          <SectionDescription>{displayKey}</SectionDescription>
        </Box>
      </Grid>

      {/* API Key ID */}
      <Grid item xs={12} sm={5} md={6}>
        <Box>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <SectionTitle>API Key ID</SectionTitle>
            <InfoTooltip
              variant="popover"
              popoverWidth={196}
              placement="bottom"
              fontSize={12}
              title="This ID is a unique identifier for this API key, used exclusively for deleting the API key via the API."
              ariaLabel="API Key ID details"
            />
          </Stack>
          <SectionDescription noWrap>{apiKeyId}</SectionDescription>
        </Box>
      </Grid>

      {/* Date Created */}
      <Grid item xs={12} sm={6} md={3}>
        <Box>
          <SectionTitle>Date Created</SectionTitle>
          <SectionDescription>{dayjs(createdAt).format('MM/DD/YY hh:mm A')}</SectionDescription>
        </Box>
      </Grid>
    </Grid>
  );
};
